const regex = /[~:\\/?#@!$&'()*+,;=%><`]+/g;

export function toURLFriendlyStringWithDashes(url: string) {
  return url.replaceAll(regex, '-');
}
export function formatExternalLink(url: string) {
  if (!url) {
    return '';
  }
  return url.startsWith('http') ? url : `//${url}`;
}
export function getCompanyProfileUrl(name: string, id: number) {
  return `/company-profiles/${toURLFriendlyStringWithDashes(name)}-${id}`;
}
